export default __webpack_public_path__ + "static/media/eye.497f1760.svg";